import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';

const Header = lazy(() => import('./components/Header/Header'));
const Hero = lazy(() => import('./components/HeroSection/Hero'));
const Footer = lazy(() => import('./components/Footer/footer'));
const Description = lazy(() => import('./components/Description/Description'));
const AboutAndCompany = lazy(() => import('./components/AboutAndCompany/AboutCompany'));
const Products = lazy(() => import('./components/Products2/Products'));
const Contact = lazy(() => import('./components/Contact/Contact'));
const Career = lazy(() => import('./components/Career/Career'));
const About = lazy(() => import('./components/AboutAndCompany/About'));
const VisionMission = lazy(() => import('./components/Description/VisionMission'));
const NotFound = lazy(() => import('./components/NotFound/NotFound'));

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Suspense fallback={<div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Poppins, sans-serif', color: '#4b9cd3' }}>Loading...</div>}>
          <Routes>
            <Route path="/" element={<><Hero /><Description /><AboutAndCompany /></>} />
            <Route path="/products" element={<Products />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/career" element={<Career />} />
            <Route path="/about" element={<About />} />
            <Route path="/visionmission" element={<VisionMission />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
